// extracted by mini-css-extract-plugin
export var container = "_4h-0";
export var fallback = "_4h-5";
export var fallbackIcon = "_4h-6";
export var hidden = "_4h-2";
export var image = "_4h-3";
export var loaded = "_4h-4";
export var placeholder = "_4h-1";